var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueDescBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    style: {
      width: "100%",
      height: "100%"
    },
    viewBox: "0 0 516.417 613.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "IssueDesc_bg",
    d: "M-6.186,4.465-1.62,86.206.295,613.141l506.134-5.47,3.8-558.249-11.641-30L470.485,6.99,23.931,0Z",
    transform: "translate(6.186)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueDescBg);
export default __webpack_public_path__ + "static/media/IssueDesc_bg.8854b5e882fbb7203fc42bc163b30c8c.svg";
export { ForwardRef as ReactComponent };